var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStudentPerformance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 30,
    viewBox: "0 0 37 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.1562 3.34375V6.62891C11.3066 6.28906 10.4004 6.0625 9.4375 6.0625V3.34375V0.625H12.1562H33.9062H36.625V3.34375V21.4688V24.1875H33.9062H18.7266L17.9336 21.4688H33.9062V3.34375H12.1562ZM29.375 14.2188L27.166 12.0098L23.0879 16.0879L22.125 17.0508L21.1621 16.0879L17.5371 12.4629L16.5742 11.5L18.5 9.57422L19.4629 10.5371L22.125 13.1992L25.2402 10.084L23.0312 7.875L23.9375 6.96875H30.2812V13.3125L29.375 14.2188ZM9.4375 10.5938C8.41797 10.5938 7.56836 11.1602 7.05859 11.9531C6.54883 12.8027 6.54883 13.8789 7.05859 14.6719C7.56836 15.5215 8.41797 16.0312 9.4375 16.0312C10.4004 16.0312 11.25 15.5215 11.7598 14.6719C12.2695 13.8789 12.2695 12.8027 11.7598 11.9531C11.25 11.1602 10.4004 10.5938 9.4375 10.5938ZM9.4375 18.75C7.45508 18.75 5.69922 17.7305 4.67969 16.0312C3.7168 14.3887 3.7168 12.293 4.67969 10.5938C5.69922 8.95117 7.45508 7.875 9.4375 7.875C11.3633 7.875 13.1191 8.95117 14.1387 10.5938C15.1016 12.293 15.1016 14.3887 14.1387 16.0312C13.1191 17.7305 11.3633 18.75 9.4375 18.75ZM5.07617 23.2812L4 26.9062H14.8184L13.7422 23.2812H5.07617ZM15.7812 20.5625L17.6504 26.9062L18.5 29.625H15.6113H3.20703H0.375L1.16797 26.9062L3.09375 20.5625H15.7812Z",
    fill: "#0962AD",
    fillOpacity: 0.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStudentPerformance);
export default __webpack_public_path__ + "static/media/student-performance.9859a5d28accf55b25004b09b2e3a5d3.svg";
export { ForwardRef as ReactComponent };